import type { CandidateFacet, EvidenceCoverageEntry, EvidenceState } from '@/types/engineer'
import { EVIDENCE_STATE_META, EvidenceStateDot } from '@/components/Shared/EvidenceStateBadge'

// EVIDENCE_STATE_META is an exhaustive Record declared in canonical order, so
// deriving from it keeps this list in sync if the EvidenceState union grows.
const CANONICAL_STATE_ORDER = Object.keys(EVIDENCE_STATE_META) as EvidenceState[]

export function summarizeEvidenceCoverage(facets: CandidateFacet[]): EvidenceCoverageEntry[] {
  const counts = new Map<EvidenceState, number>()
  for (const facet of facets) {
    counts.set(facet.evidenceState, (counts.get(facet.evidenceState) ?? 0) + 1)
  }
  return CANONICAL_STATE_ORDER.filter((state) => (counts.get(state) ?? 0) > 0).map((state) => ({
    state,
    count: counts.get(state) ?? 0,
  }))
}

interface EvidenceCoverageStripProps {
  facets: CandidateFacet[]
}

export function EvidenceCoverageStrip({ facets }: EvidenceCoverageStripProps) {
  const coverage = summarizeEvidenceCoverage(facets)
  return (
    <div>
      <div className="flex flex-wrap items-center gap-[6px]">
        {facets.map((facet) => (
          <EvidenceStateDot key={facet.facetType} state={facet.evidenceState} />
        ))}
      </div>
      <div className="mt-3 flex flex-col gap-[6px]">
        {coverage.map((entry) => (
          <div key={entry.state} className="flex items-center justify-between">
            <span className="inline-flex items-center gap-[7px]">
              <EvidenceStateDot state={entry.state} />
              <span className="font-mono text-[11px] text-muted-foreground">
                {entry.state.toLowerCase()}
              </span>
            </span>
            <span className="font-mono text-[11px] font-semibold text-foreground">{entry.count}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
